import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { Tabs, TabPanel } from "react-tabs";

import "video-react/dist/video-react.css"; // Import the CSS styles for the player
import { SERVER_URL } from "../../api/url";
import { useState } from "react";
import useStore from "../../store/information";

const CourseDetailsMain = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [course, setCourse] = useState([])
  const { setCourseName, setCourseId } = useStore();
  const {
    courseImg,
    courseDescription,
    courseAuthor,
    courseLesson,
    courseDuration,
    levels,
    courseRegularPrice,
    courseLanguage,
    discount,
    enrolled,
    start,
    ages,
    video,
    courseID,
    courseName,
    relatedcourse,
    lectures,
    name,
    count
  } = props;
  useEffect(() => {
    lectures > 0 && (
      fetchCourse()
    )
  }, []);

  const fetchCourse = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${SERVER_URL}/course/get_course/${courseID}`);
      if (response.status === 200) {
        setCourse(response?.data?.data);
      }
    } catch (err) {
      console.error(err.response);
    } finally {
      setLoading(false);  // Ensure loading is set to false when done
    }
  };

const cleanContent = (html) => {
    if (!html) return "";

    return html
      .split(/<br\s*\/?>|<\/?p>/) 
      .filter(item => item.trim() !== "" && item !== "&nbsp;")
      .map(text => `<p>${text}</p>`)
      .join("");
  };


  const handleZoom = () => {
    setCourseId(courseID)
    setCourseName(courseName)
    const token = localStorage.getItem("userToken");
    if (!token) {
    navigate('/login');
    return; 
  }

    if (!name?.toLowerCase().includes("video")) {
      navigate('/Zoom', { state: { courseID, courseName } });
    } else {
      navigate('/payment', { state: { courseID, courseName } });
    }
  };

  // Calculate discounted price if a discount exists
  const discountedPrice = (courseRegularPrice && discount)
    ? (courseRegularPrice - (courseRegularPrice * discount) / 100).toFixed(0)
    : null;

  return (
    <div className="back__course__page_grid react-courses__single-page pb---16 pt---110">
      <div className="container pb---70">
        {
          !loading && (
            <div className="row">
              <div className="col-lg-8">
                <div className="course-details-video mb---30">
                  <div>
                    {
                      video && (
                        <div className="w-full max-w-full" style={{ height: '400px' }}>
                          <video
                            playsInline
                            poster={courseImg}  // Use image as poster before the video loads
                            src={`https://back.yourfrenchteachers.com/${video}`}  // Video URL
                            autoPlay  // Enable autoplay
                            crossOrigin="anonymous"  // Ensure CORS is enabled if required
                            controls  // This adds the default play/pause and other controls
                            style={{
                              width: 'auto',  // Adjust width automatically to maintain aspect ratio
                              height: '100%',  // Fill the full height of the container
                              objectFit: 'contain'  // Ensure the video fits within the container without cropping
                            }}
                          >
                            {/* Optional: Custom fallback content */}
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      )
                    }


                  </div>

                </div>
                <Tabs>
                  <div className="course-single-tab">
                    <div className="tab-content" id="back-tab-content">
                      <TabPanel>
                        <div className="tab-pane">
                          <h3>About This Course</h3>
                          <div dangerouslySetInnerHTML={{ __html: cleanContent(courseDescription) }} />
                          {/* <div className="image-banner mt-3">
                        <img crossOrigin="anonymous" src={courseImg} alt="Course Image" />
                      </div> */}
                        </div>
                      </TabPanel>
                    </div>
                  </div>
                </Tabs>
              </div>

              <div className="col-lg-4 md-mt-60">

                <div className="react-sidebar react-back-course2 ml----30">
                  <div className="widget get-back-course">
            
                    {discount && discount !=="0"? (
                      <ul className="price">
                        <li>{discountedPrice} MMK</li>
                        <li>{courseRegularPrice} MMK </li>
                        <li>{discount}% OFF</li>
                      </ul>
                    ) : (
                      <ul className="price">
                        <li>{courseRegularPrice} MMK</li>
                      </ul>
                    )}

                    <ul className="price__course">
                      {start && (
                        <li>
                          <i className="icon_map_alt"></i> Course start <b>{start}</b>
                        </li>
                      )}
                      <li>
                        <i className="icon_profile"></i> Instructor <b>{courseAuthor}</b>
                      </li>
                      {
                        enrolled !== "-" && (
                          <li>
                            <i className="icon_group"></i> No of students <b>{enrolled}</b>
                          </li>
                        )
                      }
                      {courseDuration && courseDuration !== "-" && (
                        <li>
                          <i className="icon_clock_alt"></i> Duration <b>{courseDuration} Month</b>
                        </li>
                      )}
                     {
                      name?.toLowerCase().includes("video") && (
                         <li>
                        <i className="icon_book_alt"></i> Lectures <b>{count} lectures</b>
                      </li>
                      )
                     }
                      <li>
                        <i className="icon_map_alt"></i> Language <b>{courseLanguage}</b>
                      </li>
                      <li>
                        <i className="icon_map_alt"></i> Levels <b>{levels}</b>
                      </li>
                      <li>
                        <i className="icon_map_alt"></i> Ages <b>{ages}</b>
                      </li>
                    </ul>
                  </div>
                </div>

                {
                  course?.lectures?.length > 0 && !name?.toLowerCase().includes("video") && (
                    <div className="react-sidebar react-back-course2 ml----30">
                      <div className="widget get-back-course">
                        <ul className="price">
                          <li>Course Outline</li>
                        </ul>

                        <ul className="price__course">
                          {course?.lectures?.map((item, index) => (
                            <li key={index}>
                             ({index+1}) {item?.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                  )
                }

              </div>
            </div>
          )
        }

        <div className="test-btn w-100 p-4 mt-5 d-flex flex-column gap-4 full-width-form">
          <button onClick={handleZoom} type="button" className="btn btn-lg btn-primary">
            Enroll Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseDetailsMain;
